import type { ReactNode } from 'react';
import { AlertCircle, Layers3 } from 'lucide-react';
import { BrandMark, Button, Card } from '@fintracks/ui';

export function ScreenLoader() {
  return <div className="screen-loader" role="status"><BrandMark decorative width={52} height={52}/><span>Preparando workspace…</span></div>;
}

export function EmptyState({ title, description, action }: { title: string; description: string; action?: ReactNode }) {
  return <Card className="empty-state"><Layers3 aria-hidden="true"/><h3>{title}</h3><p>{description}</p>{action}</Card>;
}

export function ErrorState({ title = 'Algo saiu do esperado', description, retry, action }: { title?: string; description: string; retry?: () => void; action?: ReactNode | undefined }) {
  return <Card className="empty-state empty-state--error" role="alert"><AlertCircle aria-hidden="true"/><h3>{title}</h3><p>{description}</p>{retry && <Button onClick={retry}>Tentar novamente</Button>}{action}</Card>;
}

export function PageHeader({ eyebrow, title, description, actions }: { eyebrow?: string; title: string; description?: string; actions?: ReactNode }) {
  return <header className="page-header"><div>{eyebrow && <p className="eyebrow">{eyebrow}</p>}<h1>{title}</h1>{description && <p>{description}</p>}</div>{actions && <div className="page-header__actions">{actions}</div>}</header>;
}
